function Project(id) {
	var id = id;
	let content;
	const projectsElement = document.querySelector('.projects');
	const projectsEntryElement = document.createElement('section');
	let iframeElements = [];
	const request = new XMLHttpRequest();

	function init() {
		projectsEntryElement.classList.add('projects--entry');
		projectsEntryElement.hidden = true;
	}

	function open() {
		if (!content) {
			loadData();
		} else {
			show();
		}
	}

	function close() {
		if (projectsEntryElement && !projectsEntryElement.hidden) {
			projectsEntryElement.hidden = true;
			projectsEntryElement.addEventListener('transitionend', removeElement);
		}
	}

	function show() {
		projectsEntryElement.innerHTML = content;
		projectsElement.appendChild(projectsEntryElement);
		iframeElements = projectsEntryElement.querySelectorAll('iframe');
		resizeIframes();
		window.requestAnimationFrame(() => {
			projectsEntryElement.hidden = false;
		});
	}

	function removeElement() {
		projectsEntryElement.remove();
		projectsEntryElement.removeEventListener('transitionend', removeElement);
	}

	async function loadData() {
		const url = `${location.protocol}//${location.host}${location.pathname}projects/get/${id}`;
		const response = await fetch(url);
		content = await response.text();
		open();
	}

	function resizeIframes() {
		[...iframeElements].forEach((element) => {
			element.style.height = `${element.offsetWidth * 9 / 16}px`;
		});
	}

	request.addEventListener('readystatechange', () => {
		if (request.readyState === 4 && request.status === 200) {
			try {
				content = request.responseText;
			} catch (e) {
				console.error(`Error loading ${id} \n${e}`);
			}
			show();
		}
	});

	window.addEventListener('resize', resizeIframes);

	init();

	this.open = open;
	this.close = close;
	this.id = id;
}

export default Project;
